<template>
	<div>
      <label class="field_label">{{ label }}</label>
      <div class="embed-container">
          <iframe
                  width="560"
                  height="315"
                  :src="embedUrl"
                  frameborder="0"
                  allowfullscreen
          ></iframe>
      </div>
	</div>
</template>
<script setup>
import { defineProps, toRefs } from "vue";

const props = defineProps({
  value: {
    type: String,
    required: true
  },
  type: {
    type: String,
		default: 'youtube'
  },
  label: {
    type: String,
    required: true
  }
});
const { value, type, label } = toRefs(props);


function getYoutubeId() {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = value.value.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}

const embedUrl = `https://www.youtube.com/embed/${getYoutubeId(value)}`;

</script>

<style scoped>
.embed-container {
    position: relative;
    padding-bottom: 63%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    margin-bottom: 1rem;
}
.embed-container iframe, .embed-container object, .embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.field_label {
		display: inline-block;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 10px;
}
</style>